/**
 * Hand-coded situations barrel — flattens 9 category files into a single
 * default-exported array. Static imports (vs dynamic) keep the deck in
 * the main bundle (~80KB) for zero-network section switches.
 *
 * Loader-side filtering by category / CEFR happens in
 * `../../situations/index.ts` (see `loadSituationsDeck`).
 */

import foodDining from './food-dining.js';
import transportDirections from './transport-directions.js';
import socialSmalltalk from './social-smalltalk.js';
import dailyLife from './daily-life.js';
import shopping from './shopping.js';
import healthMedical from './health-medical.js';
import workWorkplace from './work-workplace.js';
import phoneComms from './phone-comms.js';
import emergenciesSafety from './emergencies-safety.js';

const allSituations = [
  ...foodDining,
  ...transportDirections,
  ...socialSmalltalk,
  ...dailyLife,
  ...shopping,
  ...healthMedical,
  ...workWorkplace,
  ...phoneComms,
  ...emergenciesSafety
];

export default allSituations;
